import React, { useContext } from 'react';
import { WrapDataGrid } from 'components/DataGrid/Style';
import { AssessmentsContext } from './AssessmentsContext';

const AssessmentsC = () => {
    const { screenTypeItem } = useContext(AssessmentsContext)

    return (
        <WrapDataGrid overflow={screenTypeItem.overflow}>
            <screenTypeItem.component />
        </WrapDataGrid>
    );
}

export default AssessmentsC
